"use-client";
import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./styles.module.css";

const FromWhomTabs = ({ criteria, fromWhomContent }) => {
  const filterOwnerParams = criteria?.params?.find((item) => item?.key === "owner");
  const selectedId = filterOwnerParams?.ownerType || "all";

  const activeFromWhomTabClass = (id) => {
    return classNames({
      [styles.fromWhomItem]: true,
      [styles.fromWhomActive]: id === selectedId,
    });
  };

  return (
    <div className={styles.wrapper}>
      {fromWhomContent.map((item, index) => (
        <a href={`${item.path}`} className={activeFromWhomTabClass(item.id)} key={index}>
          {item.name}
        </a>
      ))}
    </div>
  );
};

FromWhomTabs.propTypes = {
  criteria: PropTypes.object,
  fromWhomContent: PropTypes.array,
};

export default FromWhomTabs;
